<svg viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 1.50439V6.75439C6 7.57977 5.402 7.87939 5 7.87939H0V7.12939H4.996C5.15 7.12489 5.33333 7.05664 5.33333 6.75439C5.33333 6.45214 5.15 6.38389 4.996 6.37939H0V1.12939C0 0.71577 0.299 0.379395 0.666667 0.379395H5C5.402 0.379395 6 0.67902 6 1.50439Z" fill="currentColor"/>
</svg>
